import React from "react";
import styled from "styled-components";
import { colors } from "sweet-web/lib/styles";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px 0;
  overflow: visible;
  margin-top: 10px;
  padding-bottom: 40px;
  width: 100%;
  /* flex: 1; */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  @media screen and (max-width: 600px) {
    /* mobile styling */
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 0;
  }
`;

type Props = {
  children: React.ReactNode[]; // items must accept width property
  itemMinWidth?: number;
  itemMaxWidth?: number;
};

const Carousel: React.FC<Props> = props => {
  // calculate width of item so they fill width of container and are within min and max

  return <Wrapper>{props.children}</Wrapper>;
};

export default Carousel;
